import { toZonedTime } from 'date-fns-tz';

export interface IAppointmentSlot {
  displayStartTime: Date;
  utcStartTime: Date;
  utcEndTime: Date;
}

export interface IProviderCalendarApiResponse {
  slots: IAppointmentSlotApiResponse[];
}

export interface IAppointmentSlotApiResponse {
  start: string;
  end: string;
}

export function convertApiResponse(response: IAppointmentSlotApiResponse, providerTimeZone: string): IAppointmentSlot {
  const displayStartTime = toZonedTime(response.start, providerTimeZone);
  return {
    displayStartTime,
    utcStartTime: new Date(response.start),
    utcEndTime: new Date(response.end)
  };
}
